import VideoStreamDetailsComponent from "../../components/VideoStreamDetails";

const VideoStreamDetails = () => {
  return (
    <>
      <VideoStreamDetailsComponent />
    </>
  );
};

export default VideoStreamDetails;
